import { ɵɵdefineInjectable, Injectable, Pipe, NgModule } from '@angular/core';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

import * as ɵngcc0 from '@angular/core';
class PhoneUtilsService {
    /**
     * Transform a given phone number to international format
     *
     * @param value Phone numer
     * @param country Two-letters country code
     */
    getInternational(value, country) {
        const phoneNumber = parsePhoneNumberFromString(value, country);
        if (phoneNumber) {
            return phoneNumber.formatInternational();
        }
        return value;
    }
    /**
     * Transform a given phone number to its national format
     *
     * @param value Phone numer
     * @param country Two-letters country code
     */
    getNational(value, country) {
        const phoneNumber = parsePhoneNumberFromString(value, country);
        if (phoneNumber) {
            return phoneNumber.formatNational();
        }
        return value;
    }
    /**
     * International format without inner spaces (PNF.E164)
     *
     * Instead of "+359 88 123" it will return "+35988123"
     *
     * @param value
     * @param country
     */
    getPlain(value, country) {
        const phoneNumber = parsePhoneNumberFromString(value, country);
        if (phoneNumber) {
            return phoneNumber.number.toString();
        }
        return value ? value.replace(/ /g, "") : value;
    }
    /**
     * Is valid phone number?
     *
     * The method will return true when arguments relates to a
     * phone number from the selected country.
     *
     * @param value
     * @param country
     */
    isValid(value, country) {
        const phoneNumber = parsePhoneNumberFromString(value, country);
        if (!phoneNumber) {
            return false;
        }
        return phoneNumber.isValid();
    }
    /**
     * Reactive form validator
     *
     * Will set *phoneInvalid* property in related form control error's object.
     *
     * @param country
     */
    isValidFormControl(country) {
        return (control) => {
            if (!control.value) {
                return null;
            }
            try {
                return !this.isValid(control.value, country)
                    ? { phoneInvalid: true }
                    : null;
            }
            catch (e) {
                return { phoneInvalid: true };
            }
        };
    }
}
PhoneUtilsService.ɵfac = function PhoneUtilsService_Factory(t) { return new (t || PhoneUtilsService)(); };
PhoneUtilsService.ɵprov = ɵɵdefineInjectable({ factory: function PhoneUtilsService_Factory() { return new PhoneUtilsService(); }, token: PhoneUtilsService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PhoneUtilsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], null, null); })();

class InternationalFormatPipe {
    constructor(phoneUtilsService) {
        this.phoneUtilsService = phoneUtilsService;
    }
    transform(value, ...args) {
        return this.phoneUtilsService.getInternational(value, args[0]);
    }
}
InternationalFormatPipe.ɵfac = function InternationalFormatPipe_Factory(t) { return new (t || InternationalFormatPipe)(ɵngcc0.ɵɵdirectiveInject(PhoneUtilsService)); };
InternationalFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "internationalFormat", type: InternationalFormatPipe, pure: true });
InternationalFormatPipe.ctorParameters = () => [
    { type: PhoneUtilsService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InternationalFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'internationalFormat'
            }]
    }], function () { return [{ type: PhoneUtilsService }]; }, null); })();
InternationalFormatPipe.ctorParameters = () => [
    { type: PhoneUtilsService }
];

class NationalFormatPipe {
    constructor(phoneUtilsService) {
        this.phoneUtilsService = phoneUtilsService;
    }
    transform(value, ...args) {
        return this.phoneUtilsService.getNational(value, args[0]);
    }
}
NationalFormatPipe.ɵfac = function NationalFormatPipe_Factory(t) { return new (t || NationalFormatPipe)(ɵngcc0.ɵɵdirectiveInject(PhoneUtilsService)); };
NationalFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "nationalFormat", type: NationalFormatPipe, pure: true });
NationalFormatPipe.ctorParameters = () => [
    { type: PhoneUtilsService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NationalFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'nationalFormat'
            }]
    }], function () { return [{ type: PhoneUtilsService }]; }, null); })();
NationalFormatPipe.ctorParameters = () => [
    { type: PhoneUtilsService }
];

class AngularPhoneUtilsLibModule {
}
AngularPhoneUtilsLibModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AngularPhoneUtilsLibModule });
AngularPhoneUtilsLibModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AngularPhoneUtilsLibModule_Factory(t) { return new (t || AngularPhoneUtilsLibModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AngularPhoneUtilsLibModule, { declarations: [InternationalFormatPipe, NationalFormatPipe], exports: [InternationalFormatPipe, NationalFormatPipe] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AngularPhoneUtilsLibModule, [{
        type: NgModule,
        args: [{
                declarations: [InternationalFormatPipe, NationalFormatPipe],
                exports: [InternationalFormatPipe, NationalFormatPipe]
            }]
    }], null, null); })();

/*
 * Public API Surface of angular-phone-utils-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AngularPhoneUtilsLibModule, InternationalFormatPipe, NationalFormatPipe, PhoneUtilsService };

//# sourceMappingURL=angular-phone-utils-lib.js.map